export default "__VITE_ASSET__Boo1LIzG__"